import apiClient from "./apiClient";
import { isOfflineMode } from "@/helpers/offlineMode";
import { QuoteSnapshotDocument } from "@/models/underwriting";
import { mockQuoteSnapshot } from "./underwritingMockData";

const BASE = "/quote-snapshot";

// The API returns PascalCase keys; normalise to camelCase for the frontend model.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalise(raw: any): QuoteSnapshotDocument {
  return {
    id: raw.id,
    appId: raw.appId ?? raw.ApplicationId,
    type: raw.type ?? raw.Type,
    version: raw.version ?? raw.Version,
    createdAt: raw.createdAt ?? raw.CreatedAt,
    snapshot: raw.snapshot ?? raw.Snapshot,
  };
}

const getById = async (
  appId: number,
  snapshotId: string,
  signal?: AbortSignal
): Promise<QuoteSnapshotDocument> => {
  if (isOfflineMode()) return { ...mockQuoteSnapshot, appId };
  const { data } = await apiClient.get<QuoteSnapshotDocument>(
    `${BASE}/${appId}/${snapshotId}`,
    { signal }
  );
  return normalise(data);
};

const listByApp = async (
  appId: number,
  signal?: AbortSignal
): Promise<QuoteSnapshotDocument[]> => {
  if (isOfflineMode()) return [{ ...mockQuoteSnapshot, appId }];
  const { data } = await apiClient.get<QuoteSnapshotDocument[]>(
    `${BASE}/${appId}`,
    { signal }
  );
  return Array.isArray(data) ? data.map(normalise) : [];
};

export const quoteSnapshotService = {
  getById,
  listByApp,
};
